/**
 * The company a person with seats in several companies is working in (X-04). The chosen slug is kept in
 * this browser and sent as `x-takeit4me-company` on every console API call; without one the server picks
 * the seat bound to the sign-in.
 */
const KEY = 't4-company'
let memo: string | null | undefined

export function selectedCompany(): string | null {
  if (memo !== undefined) return memo
  try { memo = localStorage.getItem(KEY) } catch { memo = null }
  return memo
}

export function setSelectedCompany(slug: string | null) {
  memo = slug
  try { if (slug) localStorage.setItem(KEY, slug); else localStorage.removeItem(KEY) } catch { /* storage blocked: kept for this tab only */ }
}

/** The company named by the subdomain (`<slug>.takeit4.me`), if the console is served on one. */
export function subdomainCompany(hostname = typeof location === 'undefined' ? '' : location.hostname): string | null {
  const m = hostname.match(/^([a-z][a-z0-9-]{2,31})\.takeit4\.me$/)
  if (!m || ['www', 'api', 'app', 'au', 'uk', 'eu', 'na', 'ops', 'preview'].includes(m[1])) return null
  return m[1]
}

/** Adds the company header to a request's headers when a company is chosen. */
export function withCompanyHeader(init: RequestInit | undefined, slug = selectedCompany()): RequestInit | undefined {
  if (!slug) return init
  const headers = new Headers(init?.headers)
  if (!headers.has('x-takeit4me-company')) headers.set('x-takeit4me-company', slug)
  return { ...init, headers }
}
